module.exports = __webpack_public_path__ + "img/socketSwivels.8345bcfa.webp";